import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { NgForm } from "@angular/forms/forms";
import { DataServiceProvider } from "../../providers/data-service/data-service";
import { TabsPage } from "../tabs/tabs";

/**
 * Generated class for the SignupPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
})
export class SignupPage {

  signup: {username?: string, password?: string} = {};
  submitted = false;
  errorMessage:string = "";

  constructor(
    public navCtrl: NavController, 
    private dataService: DataServiceProvider
  ) {
  }
  onSignup(form: NgForm) {
    this.submitted = true;

    if (form.valid) {
      this.dataService.signUpWithEmail(this.signup.username, this.signup.password)
        .then((data:any) => {
          console.log("signupdata",data);
          this.navCtrl.setRoot(TabsPage);
        })
        .catch((error:any) => {
          console.log("loginerror",error);
          this.errorMessage = error.message;
        })

      //this.navCtrl.setRoot(TabsPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts